import { CrudState } from "@/store/Crud/State";

export class State extends CrudState {
  tuev_systems = [];

  tuev_students: any[] = [];
}
